// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pBqVyliP4z9_Mz {
  position: relative;
}
.kvYIy5s0bKSXk7 {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  left: 0;
  box-sizing: border-box;
  transition: background 0.15s ease-in;
  text-align: center;
  cursor: pointer;
}
.Py1juLDSV33QEs {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  padding: 8px;
  overflow: hidden;
  border-radius: 2px;
  background: var(--ds-surface, #ffffff);
  color: var(--ds-text, #172b4d);
  text-decoration: underline;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `pBqVyliP4z9_Mz`,
	"fadeArea": `kvYIy5s0bKSXk7`,
	"fadeText": `Py1juLDSV33QEs`
};
export default ___CSS_LOADER_EXPORT___;
